import { RegionalLocaleEnum } from '@app/common/locale/domain/entities/regional-locale.enum';

/**
 * Constantes relacionadas con la configuración de locales e idiomas
 */

/**
 * Expresión regular para validar formatos de locale.
 * Acepta formatos como: 'es', 'en', 'es-BO', 'en-US', 'es-ar', 'en_us'
 *
 * Formato: idioma base soportado (es/en) opcionalmente seguido por
 * separador '-' o '_' y dos letras de región (sin importar el case)
 */
export const LOCALE_REGEX: RegExp = /^(es|en)(?:[-_][a-z]{2})?$/i;

/**
 * Conjunto de idiomas soportados en la aplicación.
 * Estos son los únicos locales que se aceptan en las URLs.
 */
export const SUPPORTED_LANGUAGES: ReadonlySet<string> = new Set([
    RegionalLocaleEnum.ES_AR,
    RegionalLocaleEnum.ES_BO,
    RegionalLocaleEnum.ES_VE,
    RegionalLocaleEnum.ES_MX,
    RegionalLocaleEnum.ES_CO,
    RegionalLocaleEnum.ES_PE,
    RegionalLocaleEnum.ES_CL,
    'en-US',
    'es-US',
]);

/**
 * Variante normalizada de los locales soportados en minúsculas.
 * Se usa para validaciones case-insensitive de prefijos en URL.
 */
export const SUPPORTED_LOCALE_PREFIXES: ReadonlySet<string> = new Set(
    Array.from(SUPPORTED_LANGUAGES, (locale: string): string => locale.toLowerCase()),
);

/**
 * Idioma por defecto cuando no se puede determinar el idioma.
 */
export const DEFAULT_LANG: string = 'es';

/**
 * Separador utilizado para dividir locale en idioma y región.
 * Ejemplo: 'es-BO' -> ['es', 'BO']
 */
export const LOCALE_SEPARATOR: string = '-';
